import { UtmTags } from '../../entities';

export type UserUtmTagsState = {
  tags: UtmTags;
};

export const userUtmTagsInitialState: UserUtmTagsState = {
  tags: {},
};
